
import type { MiniAppView } from '../types';

export const isMiniAppView = (value: string): value is MiniAppView => {
  const validViews: MiniAppView[] = ['dashboard', 'engagement', 'jobs', 'wagers', 'profile', 'initiation', 'roulette'];
  return validViews.includes(value as MiniAppView);
};

export const getValidMiniAppView = (value: string | null): MiniAppView => {
  if (value && isMiniAppView(value)) {
    return value;
  }
  return 'dashboard';
};
